import { render, staticRenderFns } from "./addQuestionnaire.vue?vue&type=template&id=397f18ec&scoped=true&"
import script from "./addQuestionnaire.vue?vue&type=script&lang=js&"
export * from "./addQuestionnaire.vue?vue&type=script&lang=js&"
import style0 from "./addQuestionnaire.vue?vue&type=style&index=0&id=397f18ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397f18ec",
  null
  
)

export default component.exports